import { signalStore } from '@ngrx/signals';
import { AbstractQueryParams, OffSubscriptionWithCatch, withActions, withSelectors } from '@res/ngg-core';
import { AddressDoc, MachineData, MachineModel, MachineRef } from '../../schema/schema.interface';
import { MachineActions } from './machine.action';
import { MachineState } from './machine.state';

export type MachineStoreModel = MachineData & { ref: MachineRef };
export interface MachineStateModel {
  machines: MachineStoreModel[];
  selectedAddress?: AddressDoc;
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean | string;
  filter?: { query: AbstractQueryParams<MachineModel>[] };
}

export const MachineStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    machines: MachineState.machines,
    machinesByAddress: MachineState.machinesByAddress,
    machineState: MachineState.machineState,
  }),
  // Actions
  withActions({
    initMachines: MachineActions.InitMachines,
    setSelectedAddress: MachineActions.SetSelectedAddress,
    getAllMachines: MachineActions.GetAllMachine,
    updateMachine: MachineActions.UpdateMachine,
    queryMachine: MachineActions.QueryMachine,
    deleteMachine: MachineActions.DeleteMachine,
  }),
);
